import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { useTranslator } from '../../i18n/useTranslator';

/**
 * Shows a validation message if one exists.
 * Supports translation via errorLocaleKey.
 */
const FieldValidationMessages = ({ sanitisedError }) => {
    const translate = useTranslator('errors');

    if (!sanitisedError || !sanitisedError.message) {
        return null;
    }

    // If error has errorLocaleKey, translate it
    const displayMessage = sanitisedError.errorLocaleKey
        ? translate(sanitisedError.errorLocaleKey, sanitisedError.context || {})
        : sanitisedError.message;

    return <div className="field-message error">{displayMessage}</div>;
};

FieldValidationMessages.propTypes = {
    sanitisedError: PropTypes.object,
};

export default React.memo(FieldValidationMessages, (prevProps, nextProps) => {
    return prevProps.sanitisedError === nextProps.sanitisedError;
});
